
import { defineComponent } from 'vue'
import DigitalAssetUpload from '../../components/DigitalAssetUpload.vue'

export default defineComponent({
    data() {
        return {
            signageItemLayoutData: {} as any
        }
    },

    props: {
        layoutDataEdit: {
            type: Object,
            default: null
        },
        layoutType: {
            type: String,
            default: ''
        },
        signageAssets: {
            type: Object,
            default: null
        },
    },

    components: {
        DigitalAssetUpload
    },

    computed: {
        assetUrl() {
            // FLOCK-6612: prefer the full-size asset file over the ~200px thumb
            // for the upload-box preview; videos keep the thumb, a poster frame
            // an <img> can display. Also guards the previously unchecked
            // .find() chain, which threw if the asset was not yet resolved.
            const displayUrl = (assetId: any): any => {
                const signageAsset = this.signageAssets.find((sa: any) => sa.id == assetId);
                if (!signageAsset) { return null; }
                if (signageAsset.assetType !== 'video' && signageAsset.assetFiles && signageAsset.assetFiles.length && signageAsset.assetFiles[0].url) {
                    return signageAsset.assetFiles[0].url;
                }
                return signageAsset.thumbUrl ? signageAsset.thumbUrl : null;
            };
            const tmpAssetUrl = [null, null];
            if (this.signageAssets && this.signageAssets.length) {
                if(this.signageItemLayoutData.media && this.signageItemLayoutData.media.asset1) {
                    tmpAssetUrl[0] = displayUrl(this.signageItemLayoutData.media.asset1_media);
                }   

                if(this.signageItemLayoutData.media && this.signageItemLayoutData.media.asset2) {
                    tmpAssetUrl[1] = displayUrl(this.signageItemLayoutData.media.asset2_media);
                }
            }
            return tmpAssetUrl;
        }
    },

    created () {
        this.signageItemLayoutData = JSON.parse(JSON.stringify(this.layoutDataEdit));
    },

    watch: {
        'signageItemLayoutData': {
            handler(newValue: any){
                this.$emit('updateLayoutData', {updatedLayoutData: newValue, shouldUpdatePreview: true});
            },
            deep: true
        },
    }
});
